exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".e404[data-v-708e5cfa]{width:100%;height:100vh;background:var(--bg-color);position:fixed;top:0;left:0;z-index:7897897897897898000;flex-direction:column}.e404 h1[data-v-708e5cfa],.e404[data-v-708e5cfa]{display:flex;justify-content:center;align-items:center}.e404 h1[data-v-708e5cfa]{font-size:3em;color:var(--sub-color);width:200px;height:200px;border-radius:50%;box-shadow:0 0 1px rgba(0,0,0,.185);background:var(--main-color)}.e404 p[data-v-708e5cfa]{font-size:1.5em;color:var(--sub-color);background:var(--main-color);box-shadow:0 0 1px rgba(0,0,0,.178)}.e404 a[data-v-708e5cfa],.e404 p[data-v-708e5cfa]{margin-top:1em;padding:.25em 2em;border-radius:5px}.e404 a[data-v-708e5cfa]{text-decoration:none;color:var(--main-color);background:var(--sub-color)}.e404 .svg[data-v-708e5cfa]{width:300px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-708e5cfa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/errors/404.vue
// module id = 515
// module chunks = 0